export const CHANNEL = {
  StripeCheckoutCreditCard: "StripeCheckoutCreditCard",
  OmipayAlipayOnline: "OmipayAlipayOnline",
}

export const PAYMENT_SOURCE = "KingDynastyOnline";